var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.formData.project_type == 2 && _vm.formData.type.includes("9")) ||
    (_vm.formData.project_meeting &&
      _vm.formData.project_meeting.process_result === "1" &&
      _vm.formData.type.includes("9"))
    ? _c(
        "div",
        {
          staticClass: "sub-form-container",
          class: {
            "sub-form-disabled":
              _vm.isTaskFormDisabled("9") || _vm.isViewTaskDisabled("9"),
            "sub-form-editing": _vm.isEditingTask("9"),
          },
        },
        [
          _c("div", { staticClass: "sub-form-title" }, [_vm._v("报价单信息")]),
          _c(
            "el-row",
            [
              _vm.showQuotationCustomerNature
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "客户类型", prop: "customer_nature" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.customer_nature,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "customer_nature", $$v)
                                },
                                expression: "formData.customer_nature",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "-1" } }, [
                                _vm._v("未认定"),
                              ]),
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v(
                                  "一类客户 [政府机构/事业单位/国有控股、国有独资企业]"
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: "3" } }, [
                                _vm._v(
                                  "二类客户[国有参股企业(实缴资本＞1000万)]"
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("三类客户[除一类、二类之外的企业]"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "业务类型",
                        prop: "items.quotation.business_type",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.changeQuotationBusinessType },
                          model: {
                            value: _vm.formData.items.quotation.business_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.quotation,
                                "business_type",
                                $$v
                              )
                            },
                            expression:
                              "formData.items.quotation.business_type",
                          },
                        },
                        _vm._l(_vm.quotationBusinessTypeList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "卡类型",
                        prop: "items.quotation.card_type",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择",
                            disabled:
                              !_vm.formData.items.quotation.business_type,
                          },
                          model: {
                            value: _vm.formData.items.quotation.card_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.quotation,
                                "card_type",
                                $$v
                              )
                            },
                            expression: "formData.items.quotation.card_type",
                          },
                        },
                        _vm._l(_vm.quotationCardTypeList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "采购金额",
                        prop: "items.quotation.money",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("9"),
                          placeholder: "请输入",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleQuotationAmountInput("money")
                          },
                          change: _vm.calcQuotationBudget,
                        },
                        model: {
                          value: _vm.formData.items.quotation.money,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.items.quotation, "money", $$v)
                          },
                          expression: "formData.items.quotation.money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "人数", prop: "items.quotation.number" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("9"),
                          placeholder: "请输入",
                        },
                        on: {
                          input: _vm.handleQuotationNumberInput,
                          change: _vm.calcQuotationBudget,
                        },
                        model: {
                          value: _vm.formData.items.quotation.number,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.quotation,
                              "number",
                              $$v
                            )
                          },
                          expression: "formData.items.quotation.number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "单人预算",
                        prop: "items.quotation.budget",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("9"),
                          placeholder: "请输入",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleQuotationAmountInput("budget")
                          },
                          change: _vm.calcQuotationMoney,
                        },
                        model: {
                          value: _vm.formData.items.quotation.budget,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.quotation,
                              "budget",
                              $$v
                            )
                          },
                          expression: "formData.items.quotation.budget",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "结算方式",
                        prop: "items.quotation.payment_method",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isViewTaskDisabled("9") },
                          model: {
                            value: _vm.formData.items.quotation.payment_method,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.quotation,
                                "payment_method",
                                $$v
                              )
                            },
                            expression:
                              "formData.items.quotation.payment_method",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("按售卡结算"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("按消费结算"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showQuotationCommissionFields
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "佣金核算方式",
                            prop: "items.quotation.accounting_method",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.isViewTaskDisabled("9") },
                              model: {
                                value:
                                  _vm.formData.items.quotation
                                    .accounting_method,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.quotation,
                                    "accounting_method",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.quotation.accounting_method",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "1" } }, [
                                _vm._v("系统核算"),
                              ]),
                              _c("el-radio", { attrs: { label: "2" } }, [
                                _vm._v("人工核算"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showQuotationCommissionFields
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "佣金",
                            prop: "items.quotation.commission",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                readonly: _vm.isViewTaskDisabled("9"),
                                placeholder: "请输入",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.handleQuotationAmountInput(
                                    "commission"
                                  )
                                },
                              },
                              model: {
                                value: _vm.formData.items.quotation.commission,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.quotation,
                                    "commission",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.quotation.commission",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showQuotationCommissionFields
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "计入业绩",
                            prop: "items.quotation.performance",
                          },
                        },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                readonly: _vm.isViewTaskDisabled("9"),
                                placeholder: "请输入",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.handleQuotationAmountInput(
                                    "performance"
                                  )
                                },
                              },
                              model: {
                                value: _vm.formData.items.quotation.performance,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData.items.quotation,
                                    "performance",
                                    $$v
                                  )
                                },
                                expression:
                                  "formData.items.quotation.performance",
                              },
                            },
                            [_c("template", { slot: "append" }, [_vm._v("%")])],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "功能菜单描述",
                        prop: "items.quotation.description",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.isViewTaskDisabled("9") },
                          model: {
                            value: _vm.formData.items.quotation.description,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formData.items.quotation,
                                "description",
                                $$v
                              )
                            },
                            expression: "formData.items.quotation.description",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("通用卡规则"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("个性化卡规则"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "服务费成本",
                        prop: "items.quotation.cost",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          readonly: _vm.isViewTaskDisabled("9"),
                          placeholder: "请输入",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.handleQuotationAmountInput("cost", 2, 8)
                          },
                        },
                        model: {
                          value: _vm.formData.items.quotation.cost,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData.items.quotation, "cost", $$v)
                          },
                          expression: "formData.items.quotation.cost",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "最终报价折扣",
                                prop: "items.quotation.final_quotation",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.isViewTaskDisabled("9"),
                                  placeholder: "请输入",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleQuotationAmountInput(
                                      "final_quotation",
                                      3
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.formData.items.quotation
                                      .final_quotation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "final_quotation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.quotation.final_quotation",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "备注",
                        prop: "items.quotation.order_rules",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          readonly: _vm.isViewTaskDisabled("9"),
                          rows: 4,
                          placeholder: "请输入需要审批的事项",
                          maxlength: 2000,
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.formData.items.quotation.order_rules,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData.items.quotation,
                              "order_rules",
                              $$v
                            )
                          },
                          expression: "formData.items.quotation.order_rules",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showQuotationTimeLimit
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "报价单时效",
                                    prop: "items.quotation.time_limit",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      readonly: _vm.isViewTaskDisabled("9"),
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value:
                                        _vm.formData.items.quotation.time_limit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.items.quotation,
                                          "time_limit",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.items.quotation.time_limit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showQuotationManagerRemarks ||
              _vm.currentQuotationApproverType
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "总经理备注" } },
                                [
                                  _vm.currentQuotationApproverType === "1"
                                    ? _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 4,
                                          maxlength: 2000,
                                          "show-word-limit": "",
                                          placeholder: "请输入总经理备注",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.items.quotation
                                              .manager_remarks,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.items.quotation,
                                              "manager_remarks",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.items.quotation.manager_remarks",
                                        },
                                      })
                                    : _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          readonly: "",
                                          value:
                                            _vm.formData.items.quotation
                                              .manager_remarks,
                                          rows: 4,
                                          placeholder: "暂无总经理备注",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.showQuotationVpRemarks ||
              _vm.currentQuotationApproverType === "2"
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "VP备注" } },
                                [
                                  _vm.currentQuotationApproverType === "2"
                                    ? _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 4,
                                          maxlength: 2000,
                                          "show-word-limit": "",
                                          placeholder: "请输入VP备注",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.items.quotation
                                              .vp_remarks,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.items.quotation,
                                              "vp_remarks",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.items.quotation.vp_remarks",
                                        },
                                      })
                                    : _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          readonly: "",
                                          value:
                                            _vm.formData.items.quotation
                                              .vp_remarks,
                                          rows: 4,
                                          placeholder: "暂无VP备注",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }